 <div  class="w-full" class:loading={loading} >
    {#if loading}
        <LoadingBox text={loadText}/>
    {/if}
    {#if $turnstileEnabled || $turnstileCreated}
    <div class="flex justify-center"> 
        <Turnstile />
    </div>
    {/if} 
     <!-- 广告 -->
    <div
      class="w-full mt-[60px] w-full grid grid-cols-2 max-mobile:mt-[30px] max-mobile:grid-cols-1 max-mobile:grid-rows-2"
    >
      <GoogleAdSense />
      <GoogleAdSense />
    </div>
    <div id="dataList">
        {#each $dialogs as dialog}
            {#if dialog.type === "small"}
                <ErrorTip {...dialog} />
            {:else if dialog.type === "picker"}
                <DataList {...dialog} />
            {/if}
        {/each}
    </div>
</div>
<script lang="ts"> 
    import GoogleAdSense from "$components/adSense/googleAdSense.svelte";
    import DataList from '$components/downloadData/List.svelte'
    import LoadingBox from '$components/loadingBox/Index.svelte'
    import ErrorTip from '$components/errorTip/Index.svelte'
    import { onDestroy } from "svelte";
    import { downloadButtonState } from "$lib/state/omnibox";
    import type { CobaltDownloadButtonState } from "$lib/types/omnibox";
    import dialogs from "$lib/state/dialogs";
    import { t } from "$lib/i18n/translations";
    import { turnstileCreated, turnstileEnabled,turnstileSolved } from "$lib/state/turnstile";
    import Turnstile from "$components/misc/Turnstile.svelte";
    let loading = $state(false)
    let checkText = $derived($t('save.checkText'))
    let turnstileText = $derived($t('save.tooltip.captcha'))
    let loadText = $state(checkText)
    let isBotCheckOngoing = $derived($turnstileEnabled && !$turnstileSolved);
    $effect(()=>{
        if(isBotCheckOngoing){
            loadText = turnstileText
            loading = true
        } else {
            loadText = checkText
        }
    })
    const unsubscribe = downloadButtonState.subscribe(
        (state: CobaltDownloadButtonState) => {
            loading = state === "think" || state === "check";
        }
    );
    onDestroy(() => unsubscribe());
    
</script>
<style>

    .loading :global(#dataList) {
        display: none;
    }
    .loading :global(#loader) {
        margin-bottom: 80px;
    }

</style>